//公共配置文件
//base.js  方法

// https://backend.cxgldata.com
// http://127.0.0.1:8000
const base = {
  host: 'http://iwenwiki.com',
  chengpin: "/api/blueberrypai/getChengpinDetails.php", //区域列表
  //api接口
  api_data: 'https://backend.cxgldata.com', // 直接使用后端地址
  //api_data: 'http://127.0.0.1:8000', // 开发环境
  api_message: '/store/get_data_store/', //门店档案查询
  // api_order: '/order/get_order_list/', //销售订单查询
  // 商品管理
  api_item: '/item/get_item_list/', //商品档案列表
  api_itemlist: '/item/get_item_lists/', //商品档案查询
  api_itemcategory_lis: '/item/get_itemcategory_list/', //商品分类列表

  // 添加请求配置
  requestConfig: {
    timeout: 8000,        // 调整为8秒
    enableCache: true,
    cacheTime: 5 * 60 * 1000,

    // 优化重试策略
    retry: {
      count: 1,          // 减少重试次数，因为重试会增加总时间
      delay: 500         // 减少重试延迟
    },

    // 增加并发数
    maxConcurrent: 5,    // 增加并发数

    // 添加预加载配置
    preload: {
      enable: true,      // 启用预加载
      interval: 4 * 60 * 1000  // 预加载间隔时间
    }
  }
}
export default base;
